module.exports = __webpack_public_path__ + "img/图片20.9179ff47.png";